import React from 'react';
import { RiDownloadLine, RiPieChartLine } from 'react-icons/ri';
import dasbImage from '../../image/dasb.png';
import bilanImage from '../../image/bilan.png';

const Visual = () => {
  return (
    <section className="lp-section">
      <div className="lp-container">
        <header className="lp-section-header lp-reveal">
          <div className="lp-badge">
            <span className="lp-badge-dot" />
            Aperçu
          </div>
          <h2 className="lp-title">
            Votre comptabilité, <span className="lp-title-accent">en images</span>
          </h2>
          <p className="lp-subtitle lp-subtitle-center">
            Dashboard interactif et rapports PDF professionnels générés
            automatiquement
          </p>
        </header>

        <div className="lp-visual-grid">
          <article className="lp-visual-card lp-reveal">
            <div className="lp-visual-card-header">
              <span>
                <RiPieChartLine />
                Tableau de bord
              </span>
            </div>
            <img src={dasbImage} alt="Dashboard Easy Compta" />
          </article>

          <article className="lp-visual-card lp-reveal lp-reveal-delay-2">
            <div className="lp-visual-card-header">
              <span>
                <RiDownloadLine />
                Rapport PDF automatique
              </span>
            </div>
            <img src={bilanImage} alt="Rapport PDF Easy Compta" />
          </article>
        </div>
      </div>
    </section>
  );
};

export default Visual;
